// import constants from './constants';
import util from "./util";
import axios from "axios";
import qs from "qs";

axios.defaults.withCredentials = true;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.headers.get['Content-Type'] = 'application/json';
// axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.interceptors.request.use((config) => {
    let url = config.url;
    // get参数编码
    if (config.method === "get" && config.params) {
        url += "?";
        let keys = Object.keys(config.params);
        for (let key of keys) {
            url += `${key}=${encodeURIComponent(config.params[key])}&`;
        }
        url = url.substring(0, url.length - 1);
        config.params = {};
    }
    config.url = url;

    if (
        config.data &&
        config.headers["Content-Type"] === "application/x-www-form-urlencoded"
    ) {
        config.data = qs.stringify(config.data);
    }

    return config;
});

let resultFilter = (value) => {
    // console.log("111111 ~ file: request.js ~ line 9 ~ resultFilter ~ value", value);
    if ((200 === value.status || 201 === value.status) && value.data) {
        if (1001 == value.data.status.code) {
            return value.data.result;
        } else {
            // console.log("111111: resultFilter -> value.data", value.data);
            throw {
                code: value.data.status.code,
                message: value.data.status.msg,
            };
        }
    }

    throw { code: -1, message: "服务异常" };
};

let doRequest = (method, api, info = {}, headers = {}) => {
    let params = {};
    let data = {};
    if ("get" === method || "delete" === method) {
        params = info;
    } else {
        data = info;
    }

    if (!headers["Content-Type"]) {
        headers["Content-Type"] = "application/json";
        if ("post" == method) {
            headers["Content-Type"] = "application/x-www-form-urlencoded";
        }
    }

    return axios({
        method,
        url: api,
        headers,
        params: params,
        data: data,
    })
        .then(resultFilter)
        .catch(function (error) {
            // console.log(
            //     "111111 ~ file: request.js ~ line 44 ~ doRequest ~ error",
            //     error
            // );

            let code = "";
            let message = "";

            if (error.response) {
                code = error.response.data.status.code;
                message = error.response.data.status.msg;
            } else {
                code = error.code;
                message = error.message;
            }

            if ("1002" == code) {
                util.removeLoginUserInfo();
                util.redirect("/login.html");
            } else {
                throw { code: -1, message: message };
            }
        });
};

let request = {
    get(api, params = {}) {
        return doRequest("get", util.wrapApi(api), params);
    },
    delete(api, params = {}) {
        return doRequest("delete", util.wrapApi(api), params);
    },
    post(api, params = {}, hasFile = false) {
        return doRequest(
            "post",
            util.wrapApi(api),
            params,
            hasFile
                ? { "Content-Type": "multipart/form-data;charset=UTF-8" }
                : {}
        );
    },
    patch(api, params = {}) {
        return doRequest("patch", util.wrapApi(api), params);
    },
};

export default request;
